import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import type { RequestTypeSuggestion } from 'state/persisted/request-type-suggestion';
import { AnalyticsContext } from '@atlaskit/analytics-next';

import messages from './messages';
import { FormLink, Description } from './styled';

interface ListItemBodyProps extends RequestTypeSuggestion {
    onClick: () => void;
    isEmbeddedRoute?: boolean;
}

const RecentFormsListItem: React.FunctionComponent<ListItemBodyProps> = ({
    portalId,
    portalName,
    name,
    descriptionHtml,
    onClick,
    isEmbeddedRoute,
    id: requestTypeId,
}) => (
    <AnalyticsContext data={{ attributes: { requestTypeId } }}>
        <>
            <FormLink
                to={`/portal/${portalId}/create/${requestTypeId}`}
                onClick={onClick}
                actionSubjectId="suggestionRequestType"
                target={isEmbeddedRoute ? '_blank' : undefined}
            >
                <FormattedMessage {...messages.linkText} values={{ portalName, formName: name }} />
            </FormLink>
            {/* Safe to use dangerouslySetInnerHTML as the HTML is sanitised by Jira */}
            <Description dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        </>
    </AnalyticsContext>
);

export default RecentFormsListItem;
